import { useQuery } from '@tanstack/react-query';
import { loadLandingStorySnapshot } from './landingStorySnapshot';
import { storyQueryKeys } from '@/queries/storyQueryKeys';

// A pending snapshot means the server is still reading the public sources; the
// build behind that answer keeps running and warms the caches the next read
// hits. Polling is what turns that into a page the visitor watches fill in,
// rather than a cold cache they can never get past.
const PENDING_POLL_INTERVAL_MS = 5_000;

export function useLandingStorySnapshot(
  propertyId: string,
  sessionKey: string,
  offerDecodeJobId?: string | null,
) {
  return useQuery({
    queryKey: storyQueryKeys.landing.snapshot(propertyId, sessionKey, offerDecodeJobId),
    queryFn: () => loadLandingStorySnapshot(propertyId, offerDecodeJobId ?? undefined),
    staleTime: 60_000,
    retry: false,
    refetchInterval: (query) =>
      query.state.data?.firstPicture.status === 'pending'
        ? PENDING_POLL_INTERVAL_MS
        : false,
  });
}
